// extracted by mini-css-extract-plugin
module.exports = {"SyntaxHighlighter":"SyntaxHighlighter_SyntaxHighlighter__P_fuF"};